import useWindowSize from "./useWindowSize";

export const MOBILE_BREAKPOINT = 768;

function useIsMobile(): boolean {
  const { width } = useWindowSize();
  return width <= MOBILE_BREAKPOINT;
}

export default useIsMobile;
